var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "dashboard-table-container",
        _vm.tableData.length < 10 ? "height" + _vm.tableData.length : "",
      ],
    },
    [
      _c(
        "el-table",
        {
          ref: "dashboardTableRef",
          staticClass: "dashboard-table-cls",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "show-summary": "",
            "sum-text": _vm.$t("total"),
            "summary-method": _vm.getSummaries,
            "header-cell-class-name": _vm.tableHeaderCls,
            stripe: "",
          },
        },
        _vm._l(_vm.labelList, function (item, index) {
          return _c("el-table-column", {
            key: item.code,
            attrs: {
              prop: item.code,
              align: item.align || "left",
              "min-width": item.minWidth,
              width: item.width,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$i18n.locale === "en"
                              ? item.name.en_name
                              : item.name.zh_name
                          ),
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }